<template>
  <div :style="areaStyle">
    <VideoComp  v-if="specialData.bannerVideoUrl" :videoUrl="specialData.bannerVideoUrl" :bannerWrap="specialData.bannerWrap" />
    <img class="video-img" src="http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325792037.png" alt="" v-else>
  </div>
</template>
<script>
export default {
  name: "videoBanner",
  props: {
    data: {
      type: Object,
    },
  },
  components: {
    VideoComp: ()=>import('./videoComponent/video.vue')
  },
  computed:{
    areaStyle() {
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } = this.specialStyle;
      return {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        marginBottom: `${blockMargeBottom ? blockMargeBottom : 0}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
      }
    },
  },
  mounted() {
    const {
      tempData: { specialData},
    } = this.data;
    this.specialData = specialData;
    this.getImageInfoList(this.specialData)
  },
  methods:{
    // 数组处理
    getImageInfoList(specialData){
      this.$apis.cms.getImageList([specialData.fileId]).then(res=>{
        let ImageInfoList = res.data
        setTimeout(()=>{
          ImageInfoList[0]&& (this.specialData.bannerVideoUrls = ImageInfoList[0].url)
          this.$forceUpdate()
        },0)
      })
    }
  },
  data() {
    const { tempData: { specialData, specialStyle, specialEntryList = []} } = this.data
    return {
      isR:false,
      specialEntryList,
      specialData,
      specialStyle
    };
  },
};
</script>
<style ang="less" scoped>
  .video-img {
    width: 700px;
    margin-bottom: 12px;
  }
</style>
